import React, { useState } from 'react';
import { MessageCircle, X } from 'lucide-react';
import SpinozaAvatar from './SpinozaAvatar';
import SpinozaBubble from './SpinozaBubble';
import SpinozaInput from './SpinozaInput';
import { useSpinoza } from '../../context/SpinozaContext';

/**
 * SpinozaOverlay — orchestrates Avatar + Bubble + Input.
 * Fixed bottom-left. Collapsed/expanded toggle.
 * z-index below modals (z-40). data-no-print for print styles.
 */
const SpinozaOverlay = () => {
  const { messages, state, isTyping, ask, isOpen, toggleOpen } = useSpinoza();
  const [inputFocused, setInputFocused] = useState(false);

  const lastMessage = messages.length > 0 ? messages[messages.length - 1] : null;
  const bubbleText = lastMessage?.role === 'assistant' ? lastMessage.text : null;
  const isThinking = state === 'thinking';

  return (
    <div
      data-no-print
      className="fixed bottom-4 right-4 z-40 flex flex-col items-end gap-2"
    >
      {/* Expanded state: bubble + input */}
      {isOpen && (
        <div className="flex flex-col gap-2 mb-2 animate-fade-in" style={{ maxWidth: 360 }}>
          {(bubbleText || isThinking) && (
            <SpinozaBubble
              text={bubbleText}
              isThinking={isThinking}
              onDismiss={toggleOpen}
            />
          )}
          <SpinozaInput
            onSend={ask}
            onFocusChange={setInputFocused}
            disabled={isThinking}
          />
        </div>
      )}

      {/* Avatar / toggle button */}
      <button
        onClick={toggleOpen}
        className="relative group focus:outline-none focus-visible:ring-2 focus-visible:ring-[#3832e3]"
        aria-label={isOpen ? 'Close Spinoza' : 'Open Spinoza'}
      >
        <div className="w-16 h-16 sm:w-24 sm:h-24">
          <SpinozaAvatar state={state} isTyping={isTyping} browCocked={inputFocused} size={96} />
        </div>
        {/* Close/open indicator */}
        <div className="absolute -top-1 -right-1 w-5 h-5 bg-white border border-zinc-300 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
          {isOpen ? <X className="w-3 h-3 text-zinc-500" /> : <MessageCircle className="w-3 h-3 text-[#3832e3]" />}
        </div>
      </button>
    </div>
  );
};

export default SpinozaOverlay;
